import { Injectable } from '@angular/core';

export type ApplicationTheme = 'light' | 'dark';

@Injectable()
export class ThemeService {
  private readonly storageKey = 'dashboardTheme';
  private currentTheme: ApplicationTheme = 'light';

  public initialize(): void {
    const storedTheme = localStorage.getItem(this.storageKey);
    this.currentTheme = storedTheme === 'dark' ? 'dark' : 'light';
    this.applyTheme();
  }

  public getTheme(): ApplicationTheme {
    return this.currentTheme;
  }

  public setTheme(theme: ApplicationTheme): void {
    this.currentTheme = theme;
    localStorage.setItem(this.storageKey, theme);
    this.applyTheme();
  }

  public toggleTheme(): void {
    this.setTheme(this.currentTheme === 'dark' ? 'light' : 'dark');
  }

  private applyTheme(): void {
    document.documentElement.setAttribute('data-bs-theme', this.currentTheme);
    document.body.classList.toggle('theme-dark', this.currentTheme === 'dark');
  }
}
